import axios from "axios";

const BASE_URL = 'https://youtube-v31.p.rapidapi.com';

const options = {
    params: {
      maxResults: '50',
    },
    headers: {
      'X-RapidAPI-Key': '468e8e5df6msh1f66354ff29d04dp180886jsnab442c44c223',
      'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
    },
  };
  
  export const fetchFromAPI = async ( url) => {
    const {data} = await axios.get(`${BASE_URL}/${url}`, options);

    return data;
  };